import {Component, Injector, OnDestroy, ViewChild} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {TechnicalDeviceApiService} from '@api/technical-device.api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {RoutesStorage} from '@helpers/routes.helper';
import {ElementGroupFormService} from './element-group-form.service';
import {DynamicFieldsGroupComponent} from '@subforms/dynamic-fields/components/dynamic-fields-group/dynamic-fields-group.component';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {distinctUntilChanged, filter, take} from 'rxjs/operators';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import {FormArray} from '@angular/forms';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-element-group-form',
    templateUrl: './element-group-form.component.html',
    providers: [
        ElementGroupFormService,
    ]
})
export class ElementGroupFormComponent extends FrontendFormComponent implements OnDestroy {

    public afterSaveMessage = NotyMessagesEnum.technicalDeviceElementGroupUpdatedMessage;

    form = this._fb.group({
        /**
         * Тип элемента ТУ и его динамические параметры
         */
        type_id: [''],
        params: this._fb.array([]),

        /**
         * НТД и ее динамические параметры
         */
        ntd_id: [''],
        ntd_params: this._fb.array([]),

        technical_cards: this._fb.array([]),

        title: [''],
        count: ['1'],
    });

    public deviceViewUrl: string;

    public device: TechnicalDeviceNamespace.ApiDataInterface;

    @ViewChild('typeParams') typeDynamicFieldsGroup: DynamicFieldsGroupComponent;
    @ViewChild('ntdParams') ntdDynamicFieldsGroup: DynamicFieldsGroupComponent;

    constructor(
        injector: Injector,
        public formService: TechnicalDeviceApiService,
        public helperService: ElementGroupFormService,
        private route: ActivatedRoute,
        private router: Router,
    ) {
        super(injector);
    }

    init() {
        const value: TechnicalDeviceNamespace.ElementGroupInterface = this.route.snapshot.data.data;
        this.device = this.route.snapshot.data.technicalDevice;

        /**
         * Прокидываем поля руками, чтобы на момент инициализации у нас уже была связь динамических полей с формой
         */
        this.ntdDynamicFieldsGroup.fbArray = this.form.get('ntd_params') as FormArray;
        this.typeDynamicFieldsGroup.fbArray = this.form.get('params') as FormArray;

        if (value) {
            /**
             * Сначала патчим форму и лишь потом инициализируем
             */
            this.setFormValues(value, this.form);


            this.form.get('type_id').disable();
            this.form.get('ntd_id').disable();
            this.form.get('params').disable();
            this.form.get('ntd_params').disable();
            this.form.get('technical_cards').disable();

            this.customInit();
        } else {
            this.customInit();

            /**
             * Дизейблим поле с типом, пока типы не загружены
             */
            this.form.get('type_id').disable();
            this.helperService.typeLoaded$.pipe(
                filter(v => v),
                take(1),
                untilDestroyed(this),
            ).subscribe(() => {
                this.form.get('type_id').enable();
            }, () => {

            });
        }

        this.deviceViewUrl = RoutesStorage.TechnicalDevice.viewElementGroups(this.device.id);
    }

    customInit() {
        this.helperService.init(this.device.id);

        this.helperService.typeParams$.pipe(
            untilDestroyed(this)
        ).subscribe((typesParams) => {
            this.typeDynamicFieldsGroup.restoreFields(typesParams);
        });

        this.helperService.ntdParams$.pipe(
            untilDestroyed(this)
        ).subscribe((ntdParams) => {
            this.ntdDynamicFieldsGroup.restoreFields(ntdParams);
        });

        this.form.get('type_id').valueChanges.pipe(
            distinctUntilChanged(),
            untilDestroyed(this),
        ).subscribe((typeId) => {
            this.helperService.handleTypeChange(typeId);
        }, () => {

        });

        this.form.get('ntd_id').valueChanges.pipe(
            distinctUntilChanged(),
            untilDestroyed(this),
        ).subscribe((ntdId) => {
            this.helperService.handleNtdChange(ntdId);

            this.form.get('type_id').patchValue('');
            this.form.get('title').patchValue('');
        }, () => {

        });
    }

    get ntdIdValue() {
        return this.form.get('ntd_id').value;
    }

    get saveUrl(): string {
        return this.formService.getElementsGroupsPath(this.device.id);
    }

    afterSave() {
        super.afterSave();
        this.isPending = true;
        this.router.navigate([this.deviceViewUrl]);
    }

    ngOnDestroy(): void {

    }
}
